export default __webpack_public_path__ + "static/media/app-gallery-white.e0875356.svg";